/**
 * Хийгдээгүй модулийн мэдэгдэл.
 *
 * Прототипийн дэлгэц хөрвүүлэгдсэн боловч ард нь ажиллах модуль
 * хараахан байхгүй тохиолдолд хэрэглэнэ. Хуурамч тоо харуулахын
 * оронд юу дутуу, юу бэлэн байгааг ил хэлнэ.
 */

import type { ReactNode } from 'react';

export function ModuleNotice({
  title,
  blockedBy,
  ready,
  children,
}: {
  title: string;
  /** Юу дутуу байна */
  blockedBy: string[];
  /** Схемд аль хэдийн бэлэн байгаа зүйл */
  ready?: string[];
  children?: ReactNode;
}) {
  return (
    <div className="flex flex-col gap-3 rounded-card border border-hair bg-panel px-card py-4">
      <div className="flex items-start gap-3">
        <span className="mt-0.5 flex size-6 shrink-0 items-center justify-center rounded-full bg-alert-bg text-[13px] text-alert-ink">
          !
        </span>
        <div className="flex flex-col gap-1">
          <span className="text-sm font-semibold">{title}</span>
          <span className="text-[12.5px] text-ink-2">
            Энэ хэсэг бүрэн бэлэн болоогүй байна. Юу дутуу, юу аль хэдийн
            ажиллаж байгааг доор харууллаа.
          </span>
        </div>
      </div>

      <div className="grid gap-3 sm:grid-cols-2">
        <div className="flex flex-col gap-1.5 rounded-well bg-alert-bg/50 px-3.5 py-3">
          <span className="text-[11px] tracking-[0.1em] text-alert-ink uppercase">Дутуу</span>
          <ul className="flex flex-col gap-1">
            {blockedBy.map((b) => (
              <li key={b} className="text-[12.5px] text-ink">· {b}</li>
            ))}
          </ul>
        </div>

        {ready?.length ? (
          <div className="flex flex-col gap-1.5 rounded-well bg-accent-100/60 px-3.5 py-3">
            <span className="text-[11px] tracking-[0.1em] text-accent-700 uppercase">
              Бэлэн
            </span>
            <ul className="flex flex-col gap-1">
              {ready.map((r) => (
                <li key={r} className="text-[12.5px] text-ink">· {r}</li>
              ))}
            </ul>
          </div>
        ) : null}
      </div>

      {children}
    </div>
  );
}
